import { render, staticRenderFns } from "./Cert.vue?vue&type=template&id=0d2a777d"
import script from "./Cert.vue?vue&type=script&lang=ts"
export * from "./Cert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports